module.exports = __webpack_public_path__ + "static/img/rrrr_26.b123ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_26.png
// module id = +bai
// module chunks = 1